if (!customElements.get('masi-life-stage')) {
  customElements.define('masi-life-stage', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const { signal } = this.controller;
      // R40: no visible motion control. Motion still stops offscreen, in a hidden tab, and with reduced motion.
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.inView = false;
      const sync = () => {
        const reduced = this.reduced.matches;
        this.dataset.running = String(this.inView && !reduced && !document.hidden);
        this.dataset.paused = String(reduced);
      };
      this.reduced.addEventListener('change', sync, { signal });
      document.addEventListener('visibilitychange', sync, { signal });
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries.some(entry => entry.isIntersecting);
        if (this.inView) this.dataset.entered = 'true';
        sync();
      }, { threshold: .12 });
      this.observer.observe(this);
      sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
    }
  });
}
